import { createSelector } from '@reduxjs/toolkit';

// First select the relevant part from the state
export const selectUserState = (state) => state.user;
export const selectUserData = createSelector(selectUserState, (state) => state.data);
export const selectIsAdmin = createSelector(
    [selectUserState],
    (state) => state.isAdmin
);
